import { render, staticRenderFns } from "./DateVcDemo.vue?vue&type=template&id=5d26a4dc&scoped=true&"
import script from "./DateVcDemo.vue?vue&type=script&lang=js&"
export * from "./DateVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./DateVcDemo.vue?vue&type=style&index=0&id=5d26a4dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d26a4dc",
  null
  
)

export default component.exports